export default __webpack_public_path__ + "static/media/residency visa entrepreneurship.36e730d1.jpg";